import React from "react";
import "./Experience.scss";

const Experience = ({ componentOffsetTop }) => {
  return (
    <div
      id="experience"
      className="experience"
      ref={(e) => (componentOffsetTop.current[5] = e)}
    >
      <h1>EXPERIENCE</h1>
      <div className="experience-container">
        <div className="ex-circle-date-one"></div>
        <div className="ex-part-one">
          <i className="ex-cap fas fa-briefcase"></i>
          <p>Development Administrator</p>
          <p>Rah Sabz</p>
          <p>IRAN - Mashhad</p>
          <p>Full Time</p>
        </div>
        <div className="ex-circle-date-two"></div>
        <div className="ex-part-two">
          <i className="ex-cap fas fa-briefcase"></i>
          <p>IT Security Administrator</p>
          <p>Varan Co</p>
          <p>IRAN - Mashhad</p>
          <p>Self-employed</p>
          <p>Full Time</p>
        </div>
        <div className="ex-circle-date-tree"></div>
        <div className="ex-part-tree">
          <i className="ex-cap fas fa-briefcase"></i>
          <p>Teaching IT</p>
          <p>City of Westminster College​</p>
          <p>UK - London</p>
          <p>volunteer</p>
        </div>

        <div className="ex-circle-date-four"></div>
        <div className="ex-part-four">
          <i className="ex-cap fas fa-briefcase"></i>
          <p>Sales Associate</p>
          <p>Tjx europe</p>
          <p>UK - London</p>
          <p>Part Time</p>
        </div>

        <div className="ex-circle-date-five"></div>
        <div className="ex-part-five">
          <i className="ex-cap fas fa-briefcase"></i>
          <p>Full Stack Web Developer</p>
          <p>Code Your Future</p>
          <p>UK - LONDON</p>
          <p>Temporary</p>
        </div>
        <div className="ex-circle-date-six"></div>
      </div>
    </div>
  );
};

export default Experience;
